function refreshAtMidnight() {
    const now = new Date();
    const timeToMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1) - now;

    // const timeToMidnightInHours = timeToMidnight / 1000 / 60 / 60;
    // console.log(timeToMidnightInHours);
    // looks good

    setTimeout(function() {
        window.location.reload(true);
    }, timeToMidnight);
}

refreshAtMidnight();
